import { Type } from "class-transformer";
export class LocalAppCacheEntry {
    fileName: string;
    @Type(() => Date)
    modifyDate: Date;
    size = 0;
    checksum: string;
}
